import { createFileRoute } from '@tanstack/react-router'
import { pageMeta } from '~/lib/site/seo'
import { cacheHeaders } from '~/lib/site/cache'
import { sortedRegions } from '~/lib/adb/chapter'
import { loadRegions } from '~/lib/adb/events-loader'
import { Container } from '~/components/ui/Container'
import { TextLink } from '~/components/ui/TextLink'
import { DonateSignupBand } from '~/components/sections/DonateSignupBand'
import { ChaptersExplorer } from '~/components/sections/ChaptersExplorer'
import { PageTitle } from '~/components/ui/PageTitle'

const TITLE = 'Find a Chapter | Direct Action Everywhere'
const DESCRIPTION =
  'We have actions happening all across the world. Find your local chapter and hang out with us!'

export const Route = createFileRoute('/chapters')({
  loader: ({ context: { queryClient } }) => loadRegions(queryClient),
  headers: () => cacheHeaders.content,
  head: () => pageMeta({ title: TITLE, description: DESCRIPTION }),
  component: Chapters,
})

function Chapters() {
  const regions = Route.useLoaderData()
  const groups = sortedRegions(regions ?? {})

  return (
    <>
      {/* Desktop: title, map and list fit the viewport below the sticky
          header, and the list scrolls inside. Below lg the page scrolls
          normally (a tall map, then the whole list), since splitting a phone
          screen left both too short. */}
      <section className="flex flex-col bg-surface pt-6 pb-4 md:pt-8 lg:h-[calc(100svh-var(--header-h))] lg:min-h-[520px] lg:pb-6">
        <Container className="flex min-h-0 flex-1 flex-col">
          <PageTitle size="md" className="mb-1 md:mb-2">
            Find a chapter
          </PageTitle>
          <p className="mt-0 mb-3 max-w-[640px] text-sm leading-6 md:mb-5 md:text-base md:leading-7">
            We have actions happening all across the world. Find your local
            chapter and hang out with us!
          </p>
          {groups.length > 0 ? (
            <div className="min-h-0 flex-1">
              <ChaptersExplorer groups={groups} />
            </div>
          ) : (
            <p className="text-base">
              We couldn't load the chapter list right now. Visit{' '}
              <TextLink href="https://dxe.io/join" external={false}>
                dxe.io/join
              </TextLink>{' '}
              to find a chapter near you.
            </p>
          )}
        </Container>
      </section>
      <section className="bg-surface pb-10">
        <Container>
          <p className="m-0 text-sm leading-6">
            Don't see your city? Visit{' '}
            <TextLink href="https://dxe.io/join">dxe.io/join</TextLink> to find
            other ways to get involved or{' '}
            <TextLink href="/new-chapter">start a chapter</TextLink> of your
            own.
          </p>
        </Container>
      </section>

      <DonateSignupBand />
    </>
  )
}
